import { apiClient } from './api/apiClient';
import type { ApiResponse, LoginResponse, Customer, LoyaltyCard, PointsTransaction, Prize, PrizeRedemption, PagedResponse } from '../types';

export const authService = {
  register: async (data: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    tenantCode: string;
  }): Promise<LoginResponse> => {
    const response = await apiClient.post<ApiResponse<LoginResponse>>('/customer/auth/register', data);
    return response.data!;
  },

  login: async (email: string, password: string): Promise<LoginResponse> => {
    const response = await apiClient.post<ApiResponse<LoginResponse>>('/customer/auth/login', { email, password });
    return response.data!;
  },

  getMe: async (): Promise<Customer> => {
    const response = await apiClient.get<ApiResponse<Customer>>('/customer/auth/me');
    return response.data!;
  },

  addLoyaltyCard: async (tenantCode: string): Promise<LoyaltyCard> => {
    const response = await apiClient.post<ApiResponse<LoyaltyCard>>('/customer/auth/loyalty-cards', { tenantCode });
    return response.data!;
  },
};

export const pointsService = {
  getHistory: async (companyId: number, page = 1, pageSize = 20): Promise<PagedResponse<PointsTransaction>> => {
    return await apiClient.get<PagedResponse<PointsTransaction>>(
      `/points/history/${companyId}?page=${page}&pageSize=${pageSize}`
    );
  },

  redeemPrize: async (prizeId: number, companyId: number): Promise<PrizeRedemption> => {
    const response = await apiClient.post<ApiResponse<PrizeRedemption>>('/points/redeem', { prizeId, companyId });
    return response.data!;
  },
};

export const prizeService = {
  getPrizes: async (companyId: number): Promise<Prize[]> => {
    const response = await apiClient.get<ApiResponse<Prize[]>>(`/prizes/${companyId}`);
    return response.data!;
  },
};
